
import _Vue from "vue";
import { Vue } from "@/vue";
import { Component } from "vue";
import DialogHeader from "./DialogHeader.vue";

export const $dialog = {
  current: _Vue.observable({
    component: null as Component | (() => Promise<Component>),
    props: null as Object | null,
    handlers: null as Object | null,
  }),
  showModal(component: Component | (() => Promise<Component>), props?: Object, handlers?: Object) {
    // later together with route names...
    // if (typeof component === "string") {
    //   const match = router.getMatchedComponents({ name: "string" })
    //   console.log(match)
    //   component = match[0]
    // }

    this.current.component = component;
    this.current.props = props;
    this.current.handlers = handlers;
  },

  close() {
    // run closing animation
    const container = document.querySelector("#dialog-container");
    container.classList.add("out");

    setTimeout(() => {
      container.classList.add("out");
      this.current.component = null;
      this.current.props = null;
      this.current.handlers = null;
    }, 200);
  },
};

// I could use a component for the header that takes the props.head as config
// and has some defaults
// or replace it with a header of its own as part of the showModal triggerConfig

// triggerConfig
// componentConfig
// default

export default Vue.extend({
  inject: ["currentDialog"],
  data() {
    return {
      component: null as Component | (() => Promise<Component>),
      props: null as Object | null,
      handlers: null as Object | null,

      header: {
        title: "Default header title",
      },
      headerComponent: DialogHeader,
    };
  },
  watch: {
    "currentDialog.component"(component: () => Promise<Component>, prev) {
      const container = this.$refs.container as HTMLDialogElement;

      if (component) {
        if (component !== prev) {
          container.showModal();
        }
      } else {
        container.close();
      }
      this.component = component;
    },
    "currentDialog.props"(props) {
      this.props = props;
      const meta = props?.meta;
      if (meta) {
        const title = typeof meta.title === "function" ? meta.title(this) : meta.title || "Default header title";
        this.header = { ...meta, title };
      } else {
        this.header = { title: "" };
      }
    },
    "currentDialog.handlers"(handlers) {
      this.handlers = handlers;
    },
  },
  mounted() {
    const container = this.$refs.container as HTMLDialogElement;

    container.addEventListener("close", (event) => {
      event.preventDefault();
      $dialog.close();
    });
  },
  methods: {
    setHeaderProps(options) {
      this.header = { ...options };
    },
  },
});
